import React from 'react';

const Gallery = () => {
    return (
        <div className="my-5">
            <h2 className="makeup-text text-center">Gallery</h2>
            <div class="container">
                <div class="row row-cols-1 row-cols-lg-4">
                    <div class="col"><img src="https://www.wetnwildbeauty.com/media/catalog/product/m/i/missyandfirece1.png" alt="" className="w-100" /></div>
                    <div class="col"><img src="https://cdn.shopify.com/s/files/1/0906/2558/products/sugar-cosmetics-mettle-matte-lipstick-06-ambrosia-soft-peach-12796087500883@2x.jpg?v=1619110152" alt="" className="w-100" /></div>
                    <div class="col"><img src="https://cdn.shopify.com/s/files/1/0906/2558/products/sugar-cosmetics-mettle-liquid-lipstick-03-estella-neutral-pinky-brown-12067423584339@2x.jpg?v=1619109902" alt="" className="w-100" /></div>
                    <div class="col"><img src="https://m.smashbox.com/media/images/products/840x840/sb_sku_C2NP41_840x840_0.jpg" alt="" className="w-100" /></div>
                    <div class="col"><img src="https://sslimages.shoppersstop.com/sys-master/images/h40/h01/14628579803166/203339566_9999.jpg_2000Wx3000H" alt="" className="w-100" /></div>
                    <div class="col"><img src="https://static.thcdn.com/images/large/original//productimg/1600/1600/12370278-1154871030313576.jpg" alt="" className="w-100" /></div>
                    <div class="col"><img src="https://www.ifchic.com/p/7/7/7/1/4/6/777146.jpg" alt="" className="w-100" /></div>
                    <div class="col"><img src="https://images.asos-media.com/products/mac-love-me-lipstick-french-silk/13394444-1-frenchsilk?$n_640w$&wid=513&fit=constrain" alt="" className="w-100" /></div>

                </div>

            </div>
        </div>
    );
};

export default Gallery;